export default [
  {
    path: '/onlineLive',
    name: 'onlineLive',
    component: () => import(/* webpackChunkName: "onlineLive" */ '@/views/onlineLive/index.vue')
  },
  {
    path: '/onlineLive/question',
    name: 'onlineLive_question',
    component: () => import(/* webpackChunkName: "onlineLive_question" */ '@/views/onlineLive/question/index.vue')
  },
  {
    path: '/onlineLive/question/answerSheet',
    name: 'onlineLive_question_answerSheet',
    component: () => import(/* webpackChunkName: "onlineLive_question_answerSheet" */ '@/views/onlineLive/question/answerSheet.vue')
  },
  {
    path: '/onlineLive/addTopic',
    name: 'onlineLive_addTopic',
    component: () => import(/* webpackChunkName: "onlineLive_addTopic" */ '@/views/onlineLive/addTopic/index.vue')
  },
  {
    path: '/onlineLive/speakHistory',
    name: 'onlineLive_speakHistory',
    component: () => import(/* webpackChunkName: "onlineLive_speakHistory" */ '@/views/onlineLive/speakHistory/index.vue')
  }
];
